import { computed } from '@angular/core';

import { StateSignals } from '@ngrx/signals';

import { AuthState } from './auth.store';

export const authComputedSignalsFactory = (store: StateSignals<AuthState>) => ({
  displayName: computed(() => store._user()?.displayName),
  photoURL: computed(() => store._user()?.photoURL)
});
